import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import * as StringUtils from '../../../utilities/stringUtils';

import { Card } from '@salesforce/design-system-react';

import { FallbackCard, SelectFallbackWizard, NoDataScreen } from '../';
import './FallbackOverview.scss';

class FallbackOverview extends Component {
  selectFallback(assetType) {
    this.props.actions.openModal('selectFallback', { assetType });
  }

  render() {
    const sortedFallbackAssets = this.props.assetTypes.sort(
      StringUtils.sortByField('type', this.props.intl.locale)
    );
    const { formatMessage } = this.props.intl;
    const heading = formatMessage({ id: 'components.ecs.fallback.heading' });
    return (
      <div className="fallback-overview-container">
        {this.props.assetTypes.length ? (
          <React.Fragment>
            <Card className="fallback-overview-card" heading={heading}>
              <div className="fallback-overview-card-body">
                {sortedFallbackAssets.map((type, idx) => (
                  <FallbackCard
                    key={`fallback-${idx}`}
                    assetType={type}
                    onSelectFallback={this.selectFallback.bind(this)}
                    isSaving={
                      this.props.fallback.isSaving.indexOf(type.type) >= 0
                    }
                  />
                ))}
              </div>
            </Card>
            <SelectFallbackWizard
              assets={this.props.assets}
              actions={this.props.actions}
              modals={this.props.modals}
              fallback={this.props.fallback}
            />
          </React.Fragment>
        ) : (
          <Card className="fallback-overview-card" hasNoHeader>
            <NoDataScreen
              screen="fallback"
              helpLink="https://help.salesforce.com/articleView?id=mc_pb_set_fallback_assets.htm&type=5"
            />
          </Card>
        )}
      </div>
    );
  }
}

FallbackOverview.propTypes = {
  assets: PropTypes.object,
  assetTypes: PropTypes.array.isRequired,
  fallback: PropTypes.object,
  actions: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(FallbackOverview);
